import { ConversionFunction } from "@lib/types/import"

export enum LoginFailedReason {
	UNKNOWN = "UNKNOWN",
	USER_DISABLED = "USER_DISABLED",
	PASSWORD_EXPIRED = "PASSWORD_EXPIRED",
	ACCOUNT_LOCKED = "ACCOUNT_LOCKED",
	ACCOUNT_EXPIRED = "ACCOUNT_EXPIRED"
}

export const loginFailedReasonConversion: ConversionFunction<LoginFailedReason> = reason => {
	switch (reason) {
		case "Unknown": return LoginFailedReason.UNKNOWN
		case "User Disabled": return LoginFailedReason.USER_DISABLED
		case "Password Expired": return LoginFailedReason.PASSWORD_EXPIRED
		case "Account Locked": return LoginFailedReason.ACCOUNT_LOCKED
		case "Account Expired": return LoginFailedReason.ACCOUNT_EXPIRED
		default: return undefined
	}
}
